$(function () {
  // show more description in property
  $(".js-show-more").on("click", function () {
    var content = this.closest(".js-description").querySelector(
      ".js-description-content"
    );

    content.style.maxHeight = content.classList.contains("is-show")
      ? "232px"
      : content.scrollHeight + "px";
    content.classList.toggle("is-show");

    $(this).toggleClass("active");
  });
});
